.container {
  width: 100%;
  position: relative;

  .name label {
    font-size: 12px;
    font-weight: 400;
  }
}
